// import dconsole from '@/plugins/debug_console'
import axios from '@/plugins/axios'

import queryClient from './query_client.js'
import { cleanQueryKey, queryKeyToUrl, ReApi, ReEndpoint, ReApiVersion } from './query_utils.ts'
import { crudOnMutate, crudOnSuccess, crudOnSettled } from './crud_mutation.js'
import { defaultOnMutate, defaultOnSuccess, defaultOnSettled, defaultMutationFn } from './mutation.js'
import {
  offlineMutationOnSettled,
  offlineMutationOnError,
  submitStoredMutations,
  storeMutationsOnMutate,
  persister,
} from './offline_mutation.js'
import dconsole from '@/plugins/debug_console'

const CRUD_MUTATION_PREFIX = 'crud'
const SUBMIT_STORE_MUTATION_PREFIX = 'submitStoreMutations'
// TODO: review and re-enable for specific endpoints (eg. documents):
// const OFFLINE_MUTATION_PREFIX = 'offline'

const defaultQueryFn = async ({ queryKey, meta }) => {
  // Automatically run GET from queryKey-based URL

  dconsole.debug(`🏁 defaultQueryFn: queryKey: ${queryKey}`)
  queryKey = cleanQueryKey(queryKey)

  // NOTE: offline is disabled for now:
  // if (!onlineManager.isOnline()) {
  //     // TODO: check what happens in real offline mode if we donc catch this
  //     dconsole.debug('🔎 defaultQueryFn: Simulating offline mode')
  //     throw new Error('Offline mode')
  // }

  if (meta?.throttle) {
    const throttleDuration = meta?.throttle === true ? 1000 : meta?.throttle
    console.debug(`⏳ Throttling query ${queryKey} by ${throttleDuration}ms`)
    await new Promise((resolve) => setTimeout(resolve, throttleDuration))
  }

  const { url, params } = queryKeyToUrl(queryKey)
  const { data } = await axios.get(url, { params })

  dconsole.debug(`✅ defaultQueryFn: queryKey: ${queryKey}`)

  return data
}

/*
 ██████  ██    ██ ███████ ██████  ██    ██  ██████ ██      ██ ███████ ███    ██ ████████
██    ██ ██    ██ ██      ██   ██  ██  ██  ██      ██      ██ ██      ████   ██    ██
██    ██ ██    ██ █████   ██████    ████   ██      ██      ██ █████   ██ ██  ██    ██
██ ▄▄ ██ ██    ██ ██      ██   ██    ██    ██      ██      ██ ██      ██  ██ ██    ██
 ██████   ██████  ███████ ██   ██    ██     ██████ ███████ ██ ███████ ██   ████    ██
    ▀▀
*/

queryClient.setDefaultOptions({
  queries: {
    queryFn: defaultQueryFn,
    persister,
  },
  mutations: {
    mutationFn: defaultMutationFn,
    onMutate: defaultOnMutate,
    onSuccess: defaultOnSuccess,
    onSettled: defaultOnSettled,
  },
})

queryClient.setMutationDefaults([CRUD_MUTATION_PREFIX], {
  onMutate: crudOnMutate,
  onSuccess: crudOnSuccess,
  onSettled: crudOnSettled,
})

// queryClient.setMutationDefaults([OFFLINE_MUTATION_PREFIX], {
//     // Default options when attempting a mutation that should work offline
//     mutationFn: offlineMutationFn,
//     onMutate: offlineMutationOnMutate,
//     onError: offlineMutationOnError,
//     onSettled: offlineMutationOnSettled,
//     onSuccess: offlineMutationOnSuccess,
// })

queryClient.setMutationDefaults([SUBMIT_STORE_MUTATION_PREFIX], {
  // Default options when submitting previously-stored mutations:
  onMutate: storeMutationsOnMutate,
  onError: offlineMutationOnError,
  onSettled: offlineMutationOnSettled,
})

export {
  queryKeyToUrl,
  cleanQueryKey,
  ReApi,
  ReApiVersion,
  ReEndpoint,
  submitStoredMutations,
  queryClient,
  CRUD_MUTATION_PREFIX,
  // OFFLINE_MUTATION_PREFIX,
  SUBMIT_STORE_MUTATION_PREFIX,
}
